import { clone } from '../clone';
import type { WorktimesRequest } from '../../store/slices/timesheet/timesheetApprovalDetails/timesheetApprovalDetailsSlice';

export function filterWorkTimes(
  workTimes: WorktimesRequest[],
): WorktimesRequest[] {
  const copyOfWorkTimes: WorktimesRequest[] = clone(workTimes);
  // Boolean() rejects '' and undefined (not just null); && ensures both fields exist — a period
  // with one missing time must not reach the API or it causes a DateTime conversion error.
  const filtered: WorktimesRequest[] = copyOfWorkTimes.filter(
    (item) => Boolean(item.startTime) && Boolean(item.endTime),
  );
  return filtered;
}
